export const QUESTION_PAYMENT_DETAIL_COLUMNS = [
    "QUESTION ID",
    "SYLLABUS",
    "MODULE",
    "DATE",
]
